<template>
  <div class="universe-stability">
    <div class="universe-stability__header">
      <h4 ref="header">UNIVERSE STABILITY</h4>
      <template v-if="!hideStabilityFlag">
        <div class="universe-stability__check is-stable" v-if="universeIsStable">
          <svg-icon :icon="pass" :width="22" :height="22"></svg-icon> {{ stableText }}
        </div>
        <div class="universe-stability__check is-unstable" v-if="!universeIsStable">
          <svg-icon :icon="error" :width="22" :height="22"></svg-icon> {{ unstableText }}
        </div>
      </template>
    </div>
    <div class="universe-stability__graph">
      <universe-stability-graph :data="universeChartData"></universe-stability-graph>
      <api-error-message v-if="!universe" apiName="universe stability graph data"></api-error-message>
    </div>
  </div>
</template>

<script>
  import UniverseStabilityGraph from '@/appComponents/graphs/UniverseStabilityGraph'
  import ApiErrorMessage from '@/appComponents/workbench/apiErrorMessage/ApiErrorMessage'
  import SvgIcon from '@/components/common/svgIcon'
  import error from '@/assets/svg/circle-error.svg'
  import pass from '@/assets/svg/circle-check.svg'
  import { transformUniverseDataForGraph } from '@/appComponents/workbench/lasGraphs/chartDataHelpers'
  import {standardDeviation, mean} from '@/common/math/utility'

  export default {
    components: {
      UniverseStabilityGraph,
      SvgIcon,
      ApiErrorMessage
    },
    props: {
      universe: {
        type: Object
      },
      hideStabilityFlag: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        stableText: 'Looking good! This universe is stable.',
        unstableText: 'This universe is not stable. It is too volatile.',
        error,
        pass
      }
    },
    computed: {
      universeChartData () {
        return transformUniverseDataForGraph(this.universe)
      },
      universeIsStable () {
        let result = false
        const hasUniverse = this.universe && this.universe.universe && this.universe.universe.length > 0
        if (hasUniverse) {
          const universeValues = this.universe.universe.map(u => u.size)
          let stability = null
          if (universeValues.length < 2) {
            stability = 1
          } else {
            stability = standardDeviation(universeValues) / mean(universeValues)
          }
          if (stability < 1 && this.universe.audience > 10000000) {
            result = true
          }
        }
        return result
      }
    }
  }
</script>

<style lang="scss">
  .universe-stability {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    &.workbench__canvas-block {
      position: absolute;
    }

    &__header {
      flex: 0 0;
      position: relative;
      height: rem(50);
    }

    &__graph {
      position: relative;
      height: calc(100% - 40px);

      /* for some reason the bar graph has an extra div wrapping it */
      > div {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }

    &__check {
      position: absolute;
      top: 0;
      right: rem(-20);
      color: white;
      height: rem(36);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 rem(15);
      border-radius: rem(4) 0 0 rem(4);

      svg {
        fill: white;
        margin-right: rem(8);
        width: rem(22) !important;
        height: rem(22) !important;
      }

      &.is-stable {
        background: color(green);
      }

      &.is-unstable {
        background: color(red);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UniverseStability.vue?73fee1d7